export const QuestionMarkModal = () => (
  <svg width="1em" height="1em" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_731_43545)">
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
        fill={"#DF7009"}
      />
      <g filter="url(#filter0_dd_731_43545)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.0013 11.667C15.3989 11.667 11.668 15.398 11.668 20.0003C11.668 24.6027 15.3989 28.3337 20.0013 28.3337C24.6037 28.3337 28.3346 24.6027 28.3346 20.0003C28.3346 15.398 24.6037 11.667 20.0013 11.667ZM20.0013 17.5003C19.6869 17.5003 19.4118 17.6742 19.2692 17.9349C19.0483 18.3387 18.542 18.487 18.1382 18.2661C17.7344 18.0453 17.5861 17.5389 17.807 17.1351C18.2302 16.3614 19.0535 15.8337 20.0013 15.8337C21.2636 15.8337 22.1404 16.6723 22.39 17.6578C22.641 18.6485 22.2597 19.8028 21.1193 20.373C20.9449 20.4602 20.8346 20.6386 20.8346 20.8337C20.8346 21.2939 20.4615 21.667 20.0013 21.667C19.5411 21.667 19.168 21.2939 19.168 20.8337C19.168 20.0073 19.6349 19.2519 20.374 18.8823C20.7529 18.6928 20.8503 18.3668 20.7744 18.0671C20.6971 17.7621 20.4416 17.5003 20.0013 17.5003ZM20.0013 24.167C20.4615 24.167 20.8346 23.7939 20.8346 23.3337C20.8346 22.8734 20.4615 22.5003 20.0013 22.5003C19.5411 22.5003 19.168 22.8734 19.168 23.3337C19.168 23.7939 19.5411 24.167 20.0013 24.167Z"
          fill={"#FFFFFF"}
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_731_43545"
        x="-6"
        y="2"
        width="52"
        height="52"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.152941 0 0 0 0 0.164706 0 0 0 0.08 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_731_43545" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="8" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.152941 0 0 0 0 0.164706 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_731_43545"
          result="effect2_dropShadow_731_43545"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_731_43545"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_731_43545">
        <path
          d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
          fill={"#FFFFFF"}
        />
      </clipPath>
    </defs>
  </svg>
)

export default QuestionMarkModal
